const state = {
    loadedGTM: [],
    currentGTM: null,
    loadedFacebookPixel: [],
    currentFacebookPixel: null,
    loadedEcommerce: {}
};

export default {
    install: (app) => {
        // This makes it available as this.$analytics in all components
        app.config.globalProperties.$analytics = {
            updateGoogleTagScript(googleTagId) {
                if (!googleTagId) return;

                state.currentGTM = googleTagId;
                if (state.loadedGTM.includes(googleTagId)) return;

                state.loadedGTM.push(googleTagId);
                const idx = state.loadedGTM.indexOf(googleTagId);

                (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
                    const f = d.getElementsByTagName(s)[0];
                    const j = d.createElement(s);
                    const dl = l !== 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.id = 'google-tag' + l;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer' + idx, googleTagId);

                this.gtmEvent('js', new Date());
                this.gtmEvent('config', googleTagId);
            },

            gtmEvent(...params) {
                if (!state.currentGTM) return;
                const layerName = 'dataLayer' + state.loadedGTM.indexOf(state.currentGTM);
                const data = params.length === 1 && typeof params[0] === 'object' ? params[0] : params;
                if (window[layerName]) {
                    window[layerName].push(data);
                }
            },

            ecommerce(action, ...params) {
                if (window.ga && window.ga.getAll) {
                    window.ga.getAll().forEach(g => {
                        const tracker = g.get('name');
                        if (typeof state.loadedEcommerce[tracker] === 'undefined') {
                            try {
                                window.ga(tracker + '.require', 'ec');
                            } catch (e) {
                                //
                            }
                            window.ga('set', 'currencyCode', 'ILS');
                            state.loadedEcommerce[tracker] = 1;
                        }
                        window.ga(tracker + '.' + action, ...params);
                        if (action !== 'ec:addProduct') {
                            window.ga(tracker + '.send', 'event', 'ecommerce', action, params[0] || action, 1);
                        }
                    });
                }
            },

            updateFacebookPixelScript(facebookPixelId) {
                if (!facebookPixelId) return;
                state.currentFacebookPixel = facebookPixelId;
                if (state.loadedFacebookPixel.includes(facebookPixelId)) return;
                state.loadedFacebookPixel.push(facebookPixelId);

                (function (f, b, e, v, n, t, s) {
                    if (f.fbq) return;
                    n = f.fbq = function () {
                        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                    };
                    if (!f._fbq) f._fbq = n;
                    n.push = n;
                    n.loaded = !0;
                    n.version = '2.0';
                    n.queue = [];
                    t = b.createElement(e);
                    t.async = !0;
                    t.src = v;
                    t.id = 'facebook-pixel';
                    s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s);
                })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

                window.fbq.disablePushState = true;
                window.fbq('init', facebookPixelId);
                window.fbq('track', 'PageView');
            },

            facebookEvent(event, ...params) {
                if (!state.currentFacebookPixel || !window.fbq) return;
                window.fbq('trackSingle', state.currentFacebookPixel, event, ...params);
            }
        };
    }
};